import React from 'react';
import { Grid } from '@mui/material'

import InspectionsHeading from "../components/InspectionsHeading";
import alwarqaLogo from "../../assets/alwarqaLogoComplete.png";
import "./styles.css";

const Header = ({ overlay = false }) => {
    return (
        <Grid
            container
            className={overlay ? 'header--overlay' : 'header--default'}
            sx={overlay ? {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                padding: '8px 24px 18px',
                zIndex: 10,
                pointerEvents: 'none',
                alignItems: 'center',
                background: 'linear-gradient(to bottom, rgba(8,20,36,0.72) 0%, rgba(8,20,36,0.28) 60%, transparent 100%)',
            } : { alignItems: 'center', padding: '12px 24px' }}
        >
            <Grid item xs={2} sx={{ pointerEvents: 'auto', display: 'flex', alignItems: 'center' }}>
                <InspectionsHeading />
            </Grid>
            <Grid item xs={7} />
            <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pointerEvents: 'auto' }}>
                <a href="http://www.alwarqasurvey.com/" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={alwarqaLogo}
                        alt="alwarqa logo"
                        className={`header__home-alwarqa-logo${overlay ? ' header__home-alwarqa-logo--overlay' : ''}`}
                    />
                </a>
            </Grid>
        </Grid>
    );
}

export default Header;
